import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { findProfileByUserId } from "../../../poll/selectors";
import { Check, Times } from "../../icons/Icons";

class ProfileGST extends React.Component {
	render() {
		const { GST } = this.props.profile;

		if (GST === null || GST === false) {
			return <Times />;
		}
		return <Check />;
	}
}

ProfileGST.propTypes = {
	userId: PropTypes.number.isRequired
};

const mapStateToProps = (state, props) => {
	return {
		profile: findProfileByUserId(state, props.userId)
	};
};

export default connect(mapStateToProps)(ProfileGST);
